import { useEffect, useRef } from 'react';

interface UseWindowResizeProps {
  onResizeStart?: () => void;
  onResizeEnd?: () => void;
  debounceDelay?: number;
}

export function useWindowResize({ onResizeStart, onResizeEnd, debounceDelay = 200 }: UseWindowResizeProps) {
  const resizeTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const resizing = useRef(false);

  useEffect(() => {
    const handleResize = () => {
      if (!resizing.current) {
        resizing.current = true;
        onResizeStart?.();
      }

      if (resizeTimeout.current) clearTimeout(resizeTimeout.current);

      resizeTimeout.current = setTimeout(() => {
        resizing.current = false;
        onResizeEnd?.();
      }, debounceDelay);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
    };
  }, [onResizeStart, onResizeEnd, debounceDelay]);
}
